import CustomTooltip from './CustomBanner';

export default CustomTooltip;
